import { render, staticRenderFns } from "./account.vue?vue&type=template&id=67714e84&scoped=true&"
var script = {}
import style0 from "./account.vue?vue&type=style&index=0&id=67714e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67714e84",
  null
  
)

export default component.exports